module.exports = "<form class=\"col-sm-4\" role=\"form\" novalidate>\n    <blnd-errors ng-model=\"errors\"></blnd-errors>\n    <div class=\"form-group signature\">\n        <div>\n            <img ng-show=\"vm.$user.signature\" ng-src=\"{{ vm.$user.signature }}\" alt=\"Plant Operator Signature\">\n            <input type=\"file\" ngf-select=\"vm.upload($file)\" ng-model=\"vm.$user.signature\" name=\"file\" ngf-accept=\"'image/*'\">\n            <p class=\"help-block\">Uploading a new signature overwrite old one!</p>\n        </div>\n    </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account/profile.signature.html
// module id = 527
// module chunks = 0